import {
  Box,
  Button,
  Icon,
  PlacementWithLogical,
  Text,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { FaCheckCircle, FaCircleNotch, FaTimesCircle } from "react-icons/fa";
import useAuthContext from "~/context/auth.context";
import { ProjectDocument } from "~/core/types";
import EmailModal from "../EmailModal";

export default function VerifyEmailRequirement({
  project,
  isTooltipOpen,
  tooltipPosition,
  tooltipLabel,
}: {
  project: ProjectDocument;
  isTooltipOpen: boolean;
  tooltipLabel?: string;
  tooltipPosition?: PlacementWithLogical;
}) {
  const { user, userData } = useAuthContext();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {project?.email?.isEmailRequired && (
        <Tooltip
          label={tooltipLabel}
          isOpen={isTooltipOpen}
          padding={4}
          fontSize={"md"}
          backgroundColor={"red.500"}
          placement={tooltipPosition}
          hasArrow
        >
          <Box
            px={8}
            py={4}
            w={"100%"}
            borderBottom={"1px"}
            borderColor={"boxBorder"}
            style={{ marginTop: "0" }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              w={"100%"}
              flexWrap="wrap"
            >
              {userData?.email ? (
                <>
                  <Icon
                    as={FaCheckCircle}
                    fontSize="18"
                    color={"descText"}
                    mr={2}
                  />
                  <Text fontSize="18" fontWeight="500" color={"descText"}>
                    {userData.email}
                  </Text>
                  <Text ml={"auto"} color={"descText"}>
                    Verified
                  </Text>
                </>
              ) : (
                <>
                  <Icon
                    as={FaCircleNotch}
                    fontSize="18"
                    color={"descText"}
                    mr={2}
                  ></Icon>
                  <Text fontSize="18" fontWeight="500" color={"descText"}>
                    Email{" "}
                    {isTooltipOpen && (
                      <Icon as={FaTimesCircle} color="#CD4A38"></Icon>
                    )}
                  </Text>

                  <Button
                    ml={"auto"}
                    fontSize={"14"}
                    colorScheme={"discord"}
                    rounded="full"
                    color={"gray.200"}
                    fontWeight={400}
                    onClick={onOpen}
                    disabled={!user}
                  >
                    Verify
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </Tooltip>
      )}
      <EmailModal isOpen={isOpen} onClose={onClose} mode="add" />
    </>
  );
}
